var app = angular.module('leonardo');

let WorkOrderCVService = function(BaseRestService) {
  return new BaseRestService('custom-values', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('custom-values', false, function(instruction) {
      instruction.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return instruction;
    });
  });
};

app.factory('WorkOrderCVService', ['BaseRestService', WorkOrderCVService]);
